module.exports = __webpack_public_path__ + "img/rz3.9109c26a.png";